const ELLIPSIS = '...';

export default (text, len) => {
  if (typeof len !== 'number') {
    throw new Error('Length is required and must be a number.');
  }

  if (!text) {
    return '';
  }

  text = text.toString();

  if (text.length > len) {
    return `${ text.substring(0, len) }${ ELLIPSIS }`;
  }

  return text;
};
